import { TranslocoService } from '@jsverse/transloco';
import { lookupLabelKey, translateLookupLabel } from '../../../_shared/helpers/lookup-label.helper';

/**
 * Document type names come from the backend (document types endpoint / stored document names) and double as values:
 * they are compared in logic and sent back in payloads, so they must stay untouched.
 *
 * For DISPLAY we translate by a stable slug of the English name under `driverDocuments.documentTypeNames`
 * ("Drivers License" / "Driver's License" → `driversLicense`, "Proof Of Residence" → `proofOfResidence`).
 * Names without a key (custom "Other" names, new backend types) fall back to the raw backend text.
 */
export const DOCUMENT_TYPE_LABEL_PREFIX = 'driverDocuments.documentTypeNames';

/**
 * Translation key a document type name resolves to, or null when there is nothing to key on.
 * The key is derived from the name, so it may not exist in the catalogue; use `getDocumentTypeLabel` for display.
 */
export function getDocumentTypeLabelKey(name: string | null | undefined): string | null {
  return lookupLabelKey(DOCUMENT_TYPE_LABEL_PREFIX, name);
}

/** Display label for a document (type) name: translated when a key exists, otherwise the raw backend text. */
export function getDocumentTypeLabel(transloco: TranslocoService, name: string | null | undefined): string {
  return translateLookupLabel(transloco, DOCUMENT_TYPE_LABEL_PREFIX, name);
}